module.exports = "<div class=\"alerts\">\n  <div *ngFor=\"let alert of alerts\" class=\"{{ cssClass(alert) }} alert-dismissable\">\n    {{alert.message}}\n    <a class=\"close\" (click)=\"removeAlert(alert)\">&times;</a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/alert/alert.component.html
// module id = ./src/app/view/alert/alert.component.html
// module chunks = main